import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import {Dialog} from "primereact/dialog";
import React, {useEffect, useState} from "react";

interface ChartInDialogButtonProps {
    identifier: string
    header?: string
    setIsDialogOpen?: (value: boolean) => void
}


const ChartInDialogButton = ({identifier, header, setIsDialogOpen}: ChartInDialogButtonProps) => {
    const [isDialogVisible, setDialogVisibility] = useState(false);
    useEffect(() => {
        if (isDialogVisible && setIsDialogOpen) {
            setIsDialogOpen(true);
        }
    }, [isDialogVisible]);
    return (
        <>
            <i className="pi pi-chart-line"
               onClick={() => {
                   setDialogVisibility(true)
               }}
               style={{cursor: "pointer"}}
            />
            <Dialog
                header={header ? header : "Chart"}
                onHide={() => {
                    setDialogVisibility(false)
                }}
                visible={isDialogVisible}
                style={{width: "min(100vw, 1000px)", height: "500px"}}
                modal={false}
                resizable={true}
                draggable={true}
                maximizable
            >
                <DatasetLineChart identifiers={[identifier]} dynamicHeight
                                  chartDialogOpen={isDialogVisible}/>
            </Dialog>
        </>)
}

export default ChartInDialogButton;